import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { PagedResponse } from '@lib/core/models/paged-response';
import { AchiCode, AchiCodePayload, AchiCodeSearch, AchiGroup, AchiGroupPayload } from '@lib/shared-ui/core/models/achi-codes.interface';

@Injectable({ providedIn: 'root' })
export class AchiCodesService {
  private readonly http = inject(HttpClient);
  private readonly dictionariesApiUrl: string;

  constructor(@Inject('DICTIONARIES_API_URL') apiUrl: string) {
    this.dictionariesApiUrl = apiUrl;
  }

  searchAchiCodes(payload: AchiCodeSearch) {
    return this.http.post<PagedResponse<AchiCode>>(`${this.dictionariesApiUrl}/achi/search`, payload);
  }

  createAchiCode(code: AchiCodePayload) {
    return this.http.post<AchiCode>(`${this.dictionariesApiUrl}/achi`, code);
  }

  updateAchiCode(code: AchiCodePayload) {
    return this.http.put<AchiCode>(`${this.dictionariesApiUrl}/achi/${code.id}`, code);
  }

  getAchiGroups() {
    return this.http.get<AchiGroup[]>(`${this.dictionariesApiUrl}/groups`);
  }

  createAchiGroup(payload: AchiGroupPayload) {
    return this.http.post<AchiGroup>(`${this.dictionariesApiUrl}/groups`, payload);
  }

  updateAchiGroup(group: AchiGroupPayload) {
    return this.http.put<AchiGroup>(`${this.dictionariesApiUrl}/groups/${group.id}`, group);
  }

  getAchiGroupById(groupId: string) {
    return this.http.get<AchiGroup>(`${this.dictionariesApiUrl}/groups/${groupId}`);
  }

  getAchiCodesByGroupId(groupId: string) {
    return this.http.get<AchiCode[]>(`${this.dictionariesApiUrl}/groups/${groupId}/achi`);
  }
}
